import React from "react";
import { Icon } from "../../Icon";
import { colours } from "../../constants/colours";
import { DataDisplayWithAdornment } from "../_components/DataDisplayWithAdornment";
import type { BooleanDataDisplayProps } from "./types";

const BooleanDataDisplay = ({
  value,
  displayValueMapping,
  showInvalidIndicator = true,
  alignment = "left",
  isInline = false,
  isBusy = false,
  isLoading = false,
  invalidText,
  emptyText = "-",
  className,
  style,
  as = "p",
}: BooleanDataDisplayProps) => {
  const actualDisplayValueMapping = Object.assign(
    {
      true: "Yes",
      false: "No",
    },
    displayValueMapping
  );
  const isEmpty = value === undefined || value === null;
  const isInvalid = typeof value !== "boolean";

  return (
    <DataDisplayWithAdornment
      showAdornment={showInvalidIndicator && !isEmpty && isInvalid}
      alignment={alignment}
      isBusy={isBusy}
      isInline={isInline}
      isLoading={isLoading}
      adornmentSlot={() => (
        <Icon
          variant="warning"
          colour={colours.status.warning}
          size={12}
          alt={invalidText}
          aria-roledescription="Warning Icon"
        />
      )}
      className={className}
      style={style}
      as={as}
    >
      {isEmpty || isInvalid
        ? emptyText
        : actualDisplayValueMapping[String(value)]}
    </DataDisplayWithAdornment>
  );
};

export default BooleanDataDisplay;
